




































import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import {Notify} from 'quasar';
import dayjs from 'dayjs';
// noinspection TypeScriptCheckImport
import relativeTime from 'dayjs/plugin/relativeTime';
import CountdownTimer from '../../../components/CountdownTimer.vue';
import OfferTile from '../../../components/OfferTile.vue';
// import {CountdownTimer, OfferTile} from '../../../components'; // FIXME: This gives `undefined`
import {CampaignStore} from '../../../store';
import {WebService} from '../../../services';
import type {ILandingPageElementOffer, IOfferLite} from '../../../store';
import type {ILBElementComponent, VueComponent} from '../../../types';

dayjs.extend(relativeTime);


@Component({
	components: {
		CountdownTimer,
		OfferTile,
	}
})
export default class LBElementOffer extends Vue implements ILBElementComponent {
	@Inject('ButtonPrimary') readonly injectedButtonPrimary!: VueComponent;
	@Inject('IconCheckCircle') readonly injectedIconCheckCircle!: VueComponent;

	@Prop({required: true})
	element!: ILandingPageElementOffer;

	@Prop({required: true})
	campaignId!: string;

	@Prop({type: Boolean, default: false})
	isEditMode!: boolean;

	@Prop({type: Boolean, default: false})
	isPreviewMode!: boolean;

	loading = true;

	get offerLite(): IOfferLite {
		return {
			name: this.element.value.name,
			description: this.element.value.description || '',
			image: this.element.value.image || ''
		};
	}

	get canClaim() {
		// always show ability to claim when embedded
		return !this.hasClaimed || this.isEmbedded;
	}

	get hasClaimed() {
		return !!CampaignStore.landingPageOpportunityOffer(this.campaignId, this.element.value.offerId);
	}

	get isEmbedded(): boolean {
		return this.isEditMode || this.isPreviewMode;
	}

	/**
	 * offer's expire timestamp in seconds
	 */
	get expireTime(): number {
		if(this.isEmbedded) {
			return 24 * 60 * 60;
		}

		return CampaignStore.landingPageOpportunityOfferExpireTime(this.campaignId, this.element.value.offerId);
	}

	mounted() {
		this.loading = false;
	}


	hasExpired(): boolean {
		return this.expireTime < dayjs().unix();
	}

	async redeemOffer() {
		if(!this.hasClaimed && !this.hasExpired()) { // hopefully redundant
			this.loading = true;
			try {
				await CampaignStore.landingPageRedeemOffer({
					campaignId: this.campaignId,
					offerId: this.element.value.offerId
				});
				Notify.create({
					position: 'bottom',
					message: `Successfully claimed ${this.element.value.name}!`,
					color: 'tp-toast',
					textColor: 'white',
				});
			} catch(error) {
				console.error(error);
				WebService.showError('Failed to claim offer.');
			}
			this.loading = false;
		}
	}
}
